// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__26_0q","range":"MonthRangeSwitch_range__p20_l","disabled":"MonthRangeSwitch_disabled__22FUu"};